/* Persistent top-of-page banner — shown on every admin page when the
 * active Razorpay key starts with `rzp_test_`. Reads the same
 * /api/admin/system-health endpoint as the rest of the dashboard, so a
 * single fetch drives both the Security Pulse and this banner.
 *
 * Hidden when the active key is a live key OR when the API is still
 * loading.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TestModeBanner = () => {
  const [state, setState] = useState({ ready: false, prefix: "" });

  useEffect(() => {
    let cancel = false;
    const load = () =>
      axios
        .get(`${API}/admin/system-health`)
        .then(({ data }) => {
          if (!cancel) {
            setState({ ready: true, prefix: data?.key_id_prefix || "" });
          }
        })
        .catch(() => {
          if (!cancel) setState({ ready: true, prefix: "" });
        });
    load();
    // Refresh every 60s so a key swap from the Secure Payment panel
    // reflects without a full page reload.
    const t = setInterval(load, 60_000);
    return () => {
      cancel = true;
      clearInterval(t);
    };
  }, []);

  if (!state.ready) return null;
  if (state.prefix !== "rzp_test_") return null;

  return (
    <div
      data-testid="admin-test-mode-banner"
      role="alert"
      className="bg-gradient-to-r from-amber-400 via-amber-300 to-amber-400 text-navy border-b-2 border-amber-600"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-2.5">
        <AlertTriangle
          className="h-5 w-5 shrink-0"
          strokeWidth={2.4}
        />
        <div className="text-[13px] sm:text-[14px] font-extrabold tracking-tight leading-tight">
          Website is running in TEST MODE.{" "}
          <span className="font-bold">
            Real customer payments will not be collected.
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestModeBanner;
